import governmentRevenueApi from 'shared/api/government-revenue/public'
import mitraWalletApi from 'shared/api/mitra-wallet'

import form from './modules/form'
import info from './modules/info'
import inquiry from './modules/inquiry'
import mitraWallet from './modules/mitra-wallet'

export default {
  state: {
    apiService: { ...governmentRevenueApi, ...mitraWalletApi },
  },
  modules: { form, info, inquiry, 'mitra-wallet': mitraWallet },
}
